const ImageListCaptionButtons = document.querySelectorAll(
  '.ImageList-itemCaptionButton',
)

if (ImageListCaptionButtons) {
  Array.prototype.forEach.call(
    ImageListCaptionButtons,
    function (captionButtonElement) {
      captionButtonElement.addEventListener('click', () => {
        const itemElement = document.querySelector(
          '#' + captionButtonElement.getAttribute('aria-controls'),
        )

        if (
          !captionButtonElement.getAttribute('aria-expanded') ||
          captionButtonElement.getAttribute('aria-expanded') == 'false'
        ) {
          captionButtonElement.setAttribute('aria-expanded', true)
          itemElement.classList.add('ImageList-item--captionExpanded')
        } else {
          captionButtonElement.setAttribute('aria-expanded', false)
          itemElement.classList.remove('ImageList-item--captionExpanded')
        }
      })
    },
  )
}
